import React, { useEffect } from 'react'
import './Stp.css'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import StpBan from '../components/StpBan'
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";

import { FaWater, FaRecycle } from "react-icons/fa";

export default function Stp() {


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: false,   // animation every time
      mirror: true,  // slide up & slide down
      offset: 120,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Sewage Treatment Plant (STP) in Madurai | MBBR, SBR, MBR Solutions</title>
        <meta name="description" content="We provide efficient Sewage Treatment Plant (STP) solutions in Madurai for apartments, hospitals, and industries. MBBR, SBR, MBR, and compact STP systems available." />
        <meta name="keywords" content="STP Plant Madurai, Sewage Treatment Plant Tamil Nadu, MBBR STP, SBR STP, MBR STP, water recycling Madurai, Sewage Treatment for Apartments Madurai" />
        <link rel="canonical" href="https://radenvironex.com/Stp" />
      </Helmet>
      <Navbar />

      <StpBan />

      <section id="stp-enviro-section">
        <div
          className="stp-card"
          data-aos="slide-up"
        >
          <div className="stp-icon">
            <FaWater />
          </div>

          <h2>Sewage Treatment Plant</h2>

          <p>
            A Sewage Treatment Plant (STP) is a system designed to treat wastewater
            from homes, apartments, hospitals, industries, and commercial buildings.
            It removes contaminants and produces treated water that is safe for reuse
            or discharge as per PCB norms.
          </p>

          {/* <div className="stp-features"> */}
          {/* <div data-aos="fade-up" data-aos-delay="100">
              <FaRecycle />
              <span>Water Reuse</span>
            </div> */}

          {/* <div data-aos="fade-up" data-aos-delay="200">
              <FaLeaf />
              <span>Eco Friendly</span>
            </div> */}
        </div>

        {/* <p className="stp-brand">
            At <strong>RAD EnviroNex</strong>, we design, install, and maintain
            efficient STP systems that support water conservation and
            environmental protection.
          </p> */}
        {/* </div> */}
      </section>





      {/* TYPES OF STP */}
      <section id="stp-types-section">
        <div className="stp-types-wrapper" data-aos="fade-up">

          <h3>Types of STP</h3>
          <p className="stp-types-intro">
            RAD EnviroNex offers MBBR, SBR, MBR, ASP, and compact STP solutions
            tailored to site conditions and Pollution Control Board (PCB) norms.
          </p>

          <div className="stp-types-grid">
            <div data-aos="slide-up">
              <FaWater />
              <span>MBBR STP (Moving Bed Bio Reactor)</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaWater />
              <span>SBR STP (Sequential Batch Reactor)</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaWater />
              <span>MBR STP (Membrane Bio Reactor)</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaWater />
              <span>Activated Sludge Process (ASP)</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaWater />
              <span>Package / Compact STP</span>
            </div>
          </div>

        </div>
      </section>








      <section id="stp-suitable-section">
        <div className="stp-suitable-wrapper" data-aos="fade-up">

          <h3 style={{ color: '#0bbcd6' }}>Best Suitable For</h3>

          <div className="stp-suitable-grid">
            <div data-aos="slide-up">
              <FaWater />
              <span>Residential Apartments & Villas</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaWater />
              <span>Hospitals & Hotels</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaWater />
              <span>IT Parks & Commercial Buildings</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaWater />
              <span>Educational Institutions</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaWater />
              <span>Industries & Factories</span>
            </div>
          </div>

        </div>
      </section>

      {/* REUSE OF TREATED WATER */}
      <section id="stp-reuse-section">
        <div className="stp-reuse-wrapper" data-aos="fade-up">

          <h3 style={{ color: '#0bbcd6' }}>Reuse of Treated Water</h3>

          <div className="stp-reuse-grid">
            <div data-aos="zoom-in">
              <FaRecycle />
              <span>Gardening & Landscaping</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="100">
              <FaRecycle />
              <span>Flushing Toilets</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="200">
              <FaRecycle />
              <span>Cooling Towers</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="300">
              <FaRecycle />
              <span>Floor & Vehicle Washing</span>
            </div>
          </div>

        </div>
      </section>











      {/* WHY CHOOSE RAD */}
      {/* <section id="stp-why-rad-section">
  <div className="stp-why-wrapper" data-aos="fade-up">

   
    <div className="stp-rad-logo" data-aos="zoom-in">
      <img src={RADLOGO} alt="RAD EnviroNex Logo" />
    </div>

    <h3>Why Choose RAD EnviroNex for STP?</h3>

    <div className="stp-why-grid">
      <div data-aos="slide-up">
        <FaWater />
        <span>
          <strong>Customized STP Design</strong><br />
          We select the right STP technology (MBBR, SBR, MBR, ASP) based on site
          conditions, flow, and usage pattern.
        </span>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaLeaf />
        <span>
          <strong>PCB Norms Compliance</strong><br />
          All our STPs are designed to meet Pollution Control Board (PCB)
          standards for safe discharge and reuse.
        </span>
      </div>

      <div data-aos="slide-up" data-aos-delay="200">
        <FaRecycle />
        <span>
          <strong>Energy-Efficient Systems</strong><br />
          Optimized aeration and automation ensure low power consumption and
          reduced operating cost.
        </span>
      </div>

      <div data-aos="slide-up" data-aos-delay="300">
        <FaWater />
        <span>
          <strong>End-to-End Solutions</strong><br />
          From planning, design, supply, installation, testing, commissioning
          to AMC – we handle everything.
        </span>
      </div>

      <div data-aos="slide-up" data-aos-delay="400">
        <FaLeaf />
        <span>
          <strong>Low Maintenance & Easy Operation</strong><br />
          User-friendly systems with minimal operator dependency and long-term
          performance.
        </span>
      </div>

      <div data-aos="slide-up" data-aos-delay="500">
        <FaRecycle />
        <span>
          <strong>Water Reuse Focused</strong><br />
          Treated water suitable for flushing, gardening, cooling towers, and
          cleaning applications.
        </span>
      </div>

      <div data-aos="slide-up" data-aos-delay="600">
        <FaLeaf />
        <span>
          <strong>Reliable After-Sales Support</strong><br />
          Quick service response, trained technicians, and preventive
          maintenance programs.
        </span>
      </div>
    </div>

  </div>
</section> */}

      {/* GOVERNMENT POLICY */}
      <section id="stp-policy-section">
        <div className="stp-policy-wrapper" data-aos="fade-up">

          <h3 style={{ color: '#0bbcd6' }}>Government Policy & Regulatory View</h3>

          <div className="stp-policy-block" data-aos="slide-up">
            <h4>1. Mandatory STPs for Large Developments</h4>
            <p>
              As per Central & State Pollution Control Boards (CPCB / SPCB):
            </p>
            <ul>
              <li>Apartments, townships, hotels, hospitals, industries, and commercial buildings must install STPs</li>
              <li>Especially mandatory when sewage generation exceeds prescribed limits</li>
            </ul>
          </div>

          <div className="stp-policy-block" data-aos="slide-up" data-aos-delay="100">
            <h4>2. Pollution Control Board (PCB) Compliance</h4>
            <ul>
              <li>Treated sewage must meet effluent discharge norms</li>
              <li>Required for Consent to Establish (CTE) and Consent to Operate (CTO)</li>
              <li>Regular monitoring and reporting is compulsory</li>
            </ul>
          </div>

          <div className="stp-policy-block" data-aos="slide-up" data-aos-delay="200">
            <h4>3. Water Reuse & Conservation Focus</h4>
            <ul>
              <li>Reuse of treated water for flushing, gardening, cooling towers</li>
              <li>Reduced dependency on freshwater sources</li>
              <li>Zero or minimal discharge concepts encouraged</li>
            </ul>
          </div>

        </div>
      </section>



      {/* BENEFITS SECTION */}
      {/* <section id="stp-benefits-section">
        <div className="stp-benefits-wrapper" data-aos="fade-up">

          <h3>Benefits of Sewage Treatment Plant</h3>

          <div className="stp-benefits-grid">
            <div data-aos="zoom-in">
              <FaRecycle />
              <span>Saves fresh water through reuse</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="100">
              <FaLeaf />
              <span>Reduces environmental pollution</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="200">
              <FaLeaf />
              <span>Meets PCB norms</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="300">
              <FaRecycle />
              <span>Low operating & maintenance cost</span>
            </div>

            <div data-aos="zoom-in" data-aos-delay="400">
              <FaLeaf />
              <span>Improves sustainability & green rating</span>
            </div>
          </div>

        </div>
      </section> */}

      <Footer />
    </>
  )
}
